jQuery(document).ready(function($) {
    'use strict';

    // The custom cursor is a decorative mouse effect: skip it for visitors
    // who ask for reduced motion.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    const $cursor = document.createElement('div');
    const $follower = document.createElement('div');

    $cursor.className = 'cursor';
    $follower.className = 'cursor-follower';

    // Purely visual; keep its text out of the accessibility tree.
    $cursor.setAttribute('aria-hidden', 'true');
    $follower.setAttribute('aria-hidden', 'true');

    const defaultCursorText = window.tankbar_cursor_settings
        ? window.tankbar_cursor_settings.i18n.title
        : 'Se här';

    $cursor.textContent = defaultCursorText;

    document.body.appendChild($cursor);
    document.body.appendChild($follower);

    const $divs = $('.hover-div');

    let storedScrollPosition = 0;

    requestAnimationFrame(function() {
        storedScrollPosition = getWindowScrollPosition();
    });

    document.addEventListener('scroll', function() {
        const currentScrollPosition = getWindowScrollPosition();
        const delta = currentScrollPosition - storedScrollPosition;

        let cursorPositionTop = parseInt($cursor.style.top);
        if (isNaN(cursorPositionTop)) {
            return;
        }

        const newCursorPositionTop = cursorPositionTop + delta;

        $cursor.style.top = `${newCursorPositionTop}px`;
        $follower.style.top = `${newCursorPositionTop}px`;

        storedScrollPosition = currentScrollPosition;
    });

    document.addEventListener('mousemove', function(e) {
        updatePositionOfCursor($cursor, e.pageX, e.pageY);
        updatePositionOfCursor($follower, e.pageX, e.pageY);
    });

    $divs.on('mouseenter', function() {
        $cursor.textContent = this.dataset.cursorText || defaultCursorText;
        $cursor.classList.add('active');
        $follower.classList.add('active');
    });

    $divs.on('mouseleave', function() {
        $cursor.classList.remove('active');
        $follower.classList.remove('active');
    });

    function updatePositionOfCursor($object, x, y) {
        const windowWidth = window.innerWidth;
        if (windowWidth <= 1023) {
            return;
        }

        $object.style.left = `${x}px`;
        $object.style.top = `${y}px`;
    }

    function getWindowScrollPosition() {
        return window.scrollY || document.documentElement.scrollTop;
    }

});
